export default {
  methods: {
    onMaxPeriodError($picker) {
      this.$nextTick(() => {
        const period = $picker.getData();
        const s = this.$utils.dateText(period.startDate);
        const e = this.$utils.dateText(period.endDate);
        const msg = `한번에 조회 가능한 기간은 최대 6개월입니다.\n조회 범위가 [${s} ~ ${e}]로\n설정되었으니 확인해주세요`;
        alert(msg);
      });
    },
  },
};
